export const saveUserPreferencesColumns = () =>
    `mutation saveUserPreferencesTrainingDetailsColumns($userPreferences: ViewFieldsInput!) {
    saveViewFields(
      viewFields: $userPreferences
    )
  }`;

export const getUserPreferencesColumns = () =>
    `query getUserPreferencesConfig {
    userPreferences {
      userPreferencesId
      viewFields {
        viewFieldId
        viewType
        fields {
          fieldId
          field
          visible
          pinned
          columnIndex
        }
      }    
    }
  }`;
